import { A9Service, AbstractDataProviderV2, IDataProviderV2 } from 'components/system';
import { RsCustomerInGroupInfo } from 'common/customers/services/types/RsCustomerInGroupInfo';
import { CustomerInGroupAdd } from 'common/customers/services/types/CustomerInGroupAdd';
import { CustomerInGroupUpdate } from 'common/customers/services/types/CustomerInGroupUpdate';
import { RsCustomerInGroup } from 'common/customers/services/types/RsCustomerInGroup';

export type ICustomerInGroupDataProvider = IDataProviderV2<RsCustomerInGroup, RsCustomerInGroupInfo, CustomerInGroupAdd, CustomerInGroupUpdate>;

@A9Service('customerInGroupDataProvider')
export class CustomerInGroupDataProvider extends AbstractDataProviderV2<
    RsCustomerInGroup,
    RsCustomerInGroupInfo,
    CustomerInGroupAdd,
    CustomerInGroupUpdate
> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/{customerId}/groups');
    }

    public patch(): Promise<any> {
        return Promise.reject('Method is not supported');
    }
}
